

const sliders = document.querySelectorAll( '.accordion-cards-slider__slider' ).forEach( slider => {
  jQuery( slider ).slick( {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    pauseOnFocus: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 501,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  } );

  jQuery( slider ).on( 'click', '.card .view-specs', function( e ) {
    e.preventDefault();
    const overlay = this.closest( '.card' ).querySelector( '.overlay' );
    jQuery( overlay ).fadeIn();
  } );

  jQuery( slider ).on( 'click', '.card .close-specs', function( e ) {
    e.preventDefault();
    const overlay = this.closest( '.card' ).querySelector( '.overlay' );

    jQuery( overlay ).fadeOut();
  } );
} );